export default "__VITE_ASSET__8RZRrdy___"